import { render, staticRenderFns } from "./PainelMobile.vue?vue&type=template&id=60965862&scoped=true&"
import script from "./PainelMobile.vue?vue&type=script&lang=js&"
export * from "./PainelMobile.vue?vue&type=script&lang=js&"
import style1 from "./PainelMobile.vue?vue&type=style&index=1&id=60965862&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60965862",
  null
  
)

export default component.exports